/**
 * Runtime check for development mode that works in BOTH Vite (ESM, browser)
 * and Jest/Node (CJS). Replaces `import.meta.env.DEV` which is Vite-only
 * syntax and causes TS1343 compile errors in ts-jest's CJS output.
 *
 * Usage: `import { isDevMode } from '@/shared/utils/isDevMode';`
 * Then replace `import.meta.env.DEV` with `isDevMode()`.
 */
export function isDevMode(): boolean {
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV !== 'production';
  }
  return true;
}
